
export type GetLectureVideoSignedUrl200 = {
  /** 미디어 콘텐츠 접근을 위한 Signed URL */
  url: string;
};
